<template>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="tit text-center">
      <p>Quantos funcionários a empresa possui?</p>
    </div>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8 col-xl-7">    
        <form @submit="onSubmit">
          <div class="form-group text-left">
            <label for="celular">Número de funcionários</label>
            <input type="text" class="form-control form-control-lg" v-model.number="QuantidadeEmpregados" v-mask="'integer'" v-focus>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="../../assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      QuantidadeEmpregados: this.solicitacao.Empresa.QuantidadeEmpregados
    }
  },
  props: {
    solicitacao: {required: true, type: Object}
  },
  methods: {
    onSubmit(e) {
      e.preventDefault()

      const newData = {
        Empresa: {
          QuantidadeEmpregados: this.QuantidadeEmpregados
        }
      }
      this.$emit('on-submit', newData)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/EmployeesAmountStep.vue